export const DEFAULT_DISCOUNT_PERCENTAGES = Object.freeze([0, 5, 10, 15, 20]);

export const toggleDiscountPercentage = (
    currentPercentage,
    selectedPercentage
) => {
    const normalizedSelection = Number(selectedPercentage);

    return Number(currentPercentage) === normalizedSelection
        ? 0
        : normalizedSelection;
};

export const buildDiscountPayload = ({
    fixedDiscountAmount = 0,
    percentageDiscount = 0,
} = {}) => {
    const fixedAmount = Number(fixedDiscountAmount);
    if (Number.isFinite(fixedAmount) && fixedAmount > 0) {
        return { discount_amount: fixedAmount };
    }

    const percentage = Number(percentageDiscount);
    if (Number.isFinite(percentage) && percentage > 0) {
        return { discount_percentage: percentage };
    }

    return { discount_amount: 0, discount_percentage: 0 };
};

export const resolvePosProfileDiscountPercentages = (configuredRows) => {
    if (!Array.isArray(configuredRows) || configuredRows.length === 0) {
        return [...DEFAULT_DISCOUNT_PERCENTAGES];
    }

    const percentages = [];
    const seen = new Set();

    configuredRows.forEach((row) => {
        const rawValue =
            row && typeof row === "object" ? row.discount_percentage : row;
        if (
            rawValue === null ||
            rawValue === undefined ||
            String(rawValue).trim() === ""
        ) {
            return;
        }

        const percentage = Number(rawValue);
        if (
            !Number.isFinite(percentage) ||
            percentage < 0 ||
            percentage > 100 ||
            seen.has(percentage)
        ) {
            return;
        }

        seen.add(percentage);
        percentages.push(percentage);
    });

    return percentages.length
        ? percentages
        : [...DEFAULT_DISCOUNT_PERCENTAGES];
};
